var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.00085 5.58508L11.5928 0.993115C11.9837 0.60223 12.6175 0.60223 13.0083 0.993115C13.3992 1.384 13.3992 2.01775 13.0083 2.40864L8.41703 6.99995L13.0083 11.5913C13.3992 11.9822 13.3992 12.6159 13.0083 13.0068C12.6175 13.3977 11.9837 13.3977 11.5928 13.0068L7.00085 8.41482L2.40888 13.0068C2.018 13.3977 1.38425 13.3977 0.99336 13.0068C0.602474 12.6159 0.602474 11.9822 0.99336 11.5913L5.58467 6.99995L0.99336 2.40864C0.602474 2.01775 0.602474 1.384 0.99336 0.993115C1.38425 0.60223 2.018 0.60223 2.40888 0.993115L7.00085 5.58508Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.3fa7ea13d63d936ba1b47ee011c7d607.svg";
export { ForwardRef as ReactComponent };